import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const ISettings = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
          >
            <path
              d="M11.8871 1L12.4516 3.98387L15.1129 5.03226L17.4516 3.74194L19.871 6.80645L17.7742 8.98387L18.0161 11.8871L20.5161 13.4194L18.6613 16.9677L15.8387 15.9194L13.7419 17.7742V20.6774L9.62902 21L9.0645 18.0968L6.32257 16.9677L3.98386 18.3387L1.5645 14.9516L3.58063 13.0161V10.2742L0.999985 8.66129L2.61289 5.03226L5.43547 5.91935L7.77418 4.3871V1.40323L11.8871 1Z"
              stroke={props.color ?? '#37474F'}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <circle
              r="3.28226"
              transform="matrix(-1 0 0 1 10.6775 11.001)"
              stroke={props.color ?? '#37474F'}
              strokeWidth="1.5"
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default ISettings;
